export { default as RouteDetailPanel } from './RouteDetailPanel';
